const RoutesShared = [
  {
    path: "/perfil/seguranca",
    lazy: async () => {
      const { default: PerfilSeguranca } =
        await import("@/pages/UserShared/PerfilSeguranca");
      return { element: <PerfilSeguranca /> };
    },
  },
  {
    path: "/editar-usuario",
    lazy: async () => {
      const { default: EditUsuario } =
        await import("@/pages/UserShared/EditUsuario");
      return { element: <EditUsuario /> };
    },
  },
  {
    path: "/tarefasExpansao",
    lazy: async () => {
      const { default: TarefasExpansao } = await import(
        "@/pages/UserShared/Menus/TarefasExpansao"
      );
      return { element: <TarefasExpansao /> };
    },
  },
  {
    path: "/reunioesExpansao",
    lazy: async () => {
      const { default: ReunioesExpansao } = await import(
        "@/pages/UserShared/Menus/ReunioesExpansao"
      );
      return { element: <ReunioesExpansao /> };
    },
  },
  {
    path: "/reunioesCalendario",
    lazy: async () => {
      const { default: ReunioesCalendario } = await import(
        "@/pages/UserShared/Menus/ReunioesCalendario"
      );
      return { element: <ReunioesCalendario /> };
    },
  },
  {
    path: "/tarefas",
    lazy: async () => {
      const { default: Tarefas } =
        await import("@/pages/UserShared/Menus/Tarefas");
      return { element: <Tarefas /> };
    },
  },
  {
    path: "/reunioes",
    lazy: async () => {
      const { default: Reunioes } =
        await import("@/pages/UserShared/Menus/Reunioes");
      return { element: <Reunioes /> };
    },
  },
  {
    path: "/reunioes/salas",
    lazy: async () => {
      const { default: ReunioesSalas } = await import(
        "@/pages/UserShared/Menus/ReunioesSalas"
      );
      return { element: <ReunioesSalas /> };
    },
  },
  {
    path: "/aniversariantes",
    lazy: async () => {
      const { default: Aniversariantes } =
        await import("@/pages/UserShared/Menus/Aniversariantes");
      return { element: <Aniversariantes /> };
    },
  },
  {
    path: "/notificacoes",
    lazy: async () => {
      const { default: Notificacoes } =
        await import("@/pages/UserShared/Menus/Notificacoes");
      return { element: <Notificacoes /> };
    },
  },
  {
    path: "/mensagens",
    lazy: async () => {
      const { default: Mensagens } =
        await import("@/pages/UserShared/Menus/Mensagens/index");
      return { element: <Mensagens /> };
    },
  },
  {
    path: "/mensagens/chat",
    lazy: async () => {
      const { default: ChatMobile } =
        await import("@/pages/UserShared/Menus/ChatMobile/ChatMobile");
      return { element: <ChatMobile /> };
    },
  },
  {
    path: "/chat-expandido/:id",
    lazy: async () => {
      const { default: ExpandedChat } =
        await import("@/pages/UserShared/ExpandedChat/ExpandedChat");
      return { element: <ExpandedChat /> };
    },
  },
];

export default RoutesShared;
